export function SET_MENU_DATA(data) {
  return {
    type: 'SET_MENU_DATA',
    payload: data
  };
}
